import {
  Box,
  Flex,
  Heading,
  Text,
  SimpleGrid,
  Container,
  useColorMode,
} from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const ShotShowHowItWorksSection = () => {
  const { colorMode } = useColorMode();

  const steps = [
    {
      number: 1,
      emoji: "🔍",
      title: "Search Ammo",
      description:
        "Search by caliber, brand, or product — just like a normal ammo site, but without being locked into one retailer.",
    },
    {
      number: 2,
      emoji: "🚚",
      title: "We Show You the Delivered Cost (Price + Shipping) to Your ZIP",
      description:
        "We calculate each retailer's actual shipping cost to your ZIP and include it in the price — so the CPR you see is the delivered cost, not an estimate.",
    },
    {
      number: 3,
      emoji: "⚖️",
      title: "You Compare the True Cost Per Round",
      description:
        "Prices are shown as delivered cost per round, so you can compare retailers apples-to-apples without clicking through multiple checkout pages.",
    },
    {
      number: 4,
      emoji: "🛒",
      title: "Buy Direct From the Retailer",
      description:
        "When you find the deal you want, we send you straight to the retailer's site to complete your purchase. We never sell ammo or take payment.",
    },
  ];

  return (
    <Box
      bg={getCurrentColor(colorMode, "whiteC.200", "blueC.500")}
      py={{ base: "64px", md: "80px" }}
      borderTop="1px solid"
      borderColor={getCurrentColor(colorMode, "grayC.500", "grayC.2000")}
      id="how-it-works"
    >
      <Container maxW="7xl">
        <Heading
          as="h2"
          fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
          fontWeight="700"
          color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
          mb={{ base: 12, md: 16 }}
          textAlign="center"
          lineHeight="tight"
        >
          How BulletScout Works
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
          {steps.map((step) => (
            <Box
              key={step.number}
              bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
              borderRadius="lg"
              p={{ base: 6, md: 8 }}
              border="1px solid"
              borderColor={getCurrentColor(
                colorMode,
                "grayC.500",
                "grayC.2000"
              )}
            >
              <Flex
                bg={"blueC.100"}
                color={"whiteC.100"}
                borderRadius="full"
                w={12}
                h={12}
                align="center"
                justify="center"
                fontWeight="700"
                fontSize="lg"
                mb={4}
              >
                {step.emoji}
              </Flex>
              <Text
                color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
                fontWeight="600"
                fontSize="md"
                lineHeight="relaxed"
              >
                {step.title}
              </Text>
              <Text
                color={getCurrentColor(colorMode, "grayC.300", "grayC.800")}
                fontSize="sm"
                mt={4}
                lineHeight="relaxed"
              >
                {step.description}
              </Text>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default ShotShowHowItWorksSection;
